/**
 * Menu parent ID of the backend-injected dynamic "My Circles" group in the
 * drawer tree. Its children carry literal (already user-readable) names, so
 * the drawer must render them verbatim instead of passing them through
 * next-intl (see `CustomDrawerNode`).
 *
 * Nothing in this repo produces this ID — it arrives via the `Menu` query
 * from the backend. Keep in sync with the backend menu seeding.
 */
export const MY_CIRCLES_DYNAMIC_PARENT_ID = 9000000001;
